<template>
  
  <ion-page id="blindfold-page">
    <ion-content>

      <div :style="styleBoard">
        <CMChessboard :fen="fen" :orientation="orientation"
              :boardSize="boardSize"  @board-move="boardMove" />
      </div>
  
      <div id="open-game-list" :style="styleGameList">
        <div v-if="gameList.length == 0">
          <div v-if="showLoadingGames">
            <p>{{ t("Loading Open Game List") }}</p>
          </div>
          <div v-else>
            <p>{{ t("No Open Games") }}</p>
          </div>
        </div>

        <div v-for="item in gameList" v-bind:key="item.index">
          <div :id="item.index" :style="oneGameStyleHeight" @click="onClick(item.index)" class="game-list-center-text"
                   :class="{
                  'reptree-selected-text-dark' : (item.selected) && isDark,
                  'reptree-move-text-dark'     : (!(item.selectedd)) && isDark,
                  'reptree-selected-text-light' : (item.selected) && !isDark,
                  'reptree-move-text-light'     : (!(item.selected)) && !isDark,
  
                  'extra-padding' : true,
                }">
            "{{ t('Game') }} {{ item.index+1 }}" {{ item.myTurn }} {{ item.color }} vs {{ item.name }}
              {{ item.opponentTurn }}
            <br>
            {{ item.rated }} {{ item.speed }}
          </div>
          <hr>
        </div>
      </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonIcon,IonPage, IonContent , modalController } from '@ionic/vue';
  
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { ref, watch } from 'vue'
  import Toolbar from '@/components/Toolbar.vue'
  import CMChessboard from '@/components/CMChessboard.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , generateErrorAlertText, getLichessData } from '@/composables/getData.js'
  import { useStringStore } from '@/stores/stringStore';
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  const emit = defineEmits(['next-item-click'])

  const connectionStore = useConnectionStore()
  const lichessAccessToken = connectionStore.getLichessAccessToken

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
  var currentGameIndexInView = 0
  var oneGameHeight = 50

  const INSTRUCTION_FONTSIZE = 16

  const stringStore = useStringStore()

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  
  const orientation = ref("white")
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  const fen = ref(INITIAL_FEN)

  const boardSize = ref(300)

  const SHOW_LIST = 0
  const showState = ref(SHOW_LIST)
  const showLoadingGames = ref(true)

  const TOOLBAR_GOTO = 0
  const TOOLBAR_REFRESH = 1
  const TOOLBAR_SCROLL_UP = 2
  const TOOLBAR_SCROLL_DOWN = 3
  const TOOLBAR_DONE = 4

  const toolbarElements = ref([
    { index : TOOLBAR_GOTO, label : t("Goto Game") ,disabled : true},
    { index : TOOLBAR_REFRESH, label : t("Refresh") ,disabled : false},
  ])

  if (showBigButtons.value) {
    toolbarElements.value.push({ index : TOOLBAR_SCROLL_UP, label : t("Up") ,disabled : false})
    toolbarElements.value.push({ index : TOOLBAR_SCROLL_DOWN, label : t("Down") ,disabled : false})
  }

  if (whichMenu == "buttons")
    toolbarElements.value.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})

  const toolbarTrigger = ref(0)

  var gameListHeight = 0
  var oneGameStyleHeight = "height : 60px;"
  var gamesPerScroll = 1

  var openGameId = ""

  const gameList = ref([])


  const styleGameList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    getOpenGames()
    menuTrigger.value++
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleGameList.value.height = boundaries['gamelist'].height + "px"
    styleGameList.value.width = boundaries['gamelist'].width + "px"
    styleGameList.value.top = boundaries['gamelist'].top + "px"
    styleGameList.value.left = boundaries['gamelist'].left + "px"

    gameListHeight = boundaries['gamelist'].height

    oneGameHeight = 50
    if (showBigButtons.value)
      oneGameHeight = Math.floor(oneGameHeight * connectionStore.getToolbarScalePercentage / 100.0)
    oneGameStyleHeight = "height : " + oneGameHeight + "px"
    gamesPerScroll = (oneGameHeight >= oneGameStyleHeight) ? 1 : Math.floor(gameListHeight / oneGameHeight)
    


    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)

    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    // reserve space for a few open games
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height - INSTRUCTION_FONTSIZE * 3 * 1.4 * 3,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const gamelistPositionTop = boardPositionTop + boardHeight
    const gamelistPositionLeft = availableSpace.leftRightIndent
    gameListHeight = availableSpace.height - gamelistPositionTop
    const gamelistWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      gamelist : {
        width : gamelistWidth,
        height : gameListHeight,
        left : gamelistPositionLeft + availableSpace.leftIndent,
        top : gamelistPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

     // reserve space for some open games
     const availableSpaceForBoard = { width : availableSpace.width - 150,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const gamelistPositionTop = boardPositionTop
    const gamelistPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    gameListHeight = availableSpace.height
    const gamelistWidth = availableSpace.width - gamelistPositionLeft

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      gamelist : {
        width : gamelistWidth,
        height : gameListHeight,
        left : gamelistPositionLeft + availableSpace.leftIndent,
        top : gamelistPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  function boardMove(arrayIndex,from,to) {
  }

  function scrollList(direction) {
    if (gameList.value.length <= 1)
      return
    if (direction == "up") 
      currentGameIndexInView -= gamesPerScroll
    else
      currentGameIndexInView += gamesPerScroll
    if (currentGameIndexInView < 0)
      currentGameIndexInView = 0
    else
    if (currentGameIndexInView >= gameList.value.length)
      currentGameIndexInView = gameList.value.length - 1
    const element = document.getElementById(String(currentGameIndexInView));
    //console.log("scroll", currentGameIndexInView,element)
    if (element != null)
      element.scrollIntoView({ behavior: "smooth" })
  }

  function toolbarClick(arrayIndex) {
    //console.log("toolbar click and show state ",arrayIndex,showState.value)
    switch (arrayIndex) {
      case TOOLBAR_DONE : 
        emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
        break
      case TOOLBAR_SCROLL_UP :
        scrollList("up")
        break
      case TOOLBAR_SCROLL_DOWN :
        scrollList("down")
        break
      case TOOLBAR_GOTO :
        if (openGameId != "") {
          connectionStore.setLichessGameId(openGameId)
          emit("next-item-click","lichess_play","Lichess Play",whichMenu)
        }
        break
      case TOOLBAR_REFRESH :
        getOpenGames()
        break
    }
  }

  function onClick(index) {

    // remove any selected
    for (var i=0; i < gameList.value.length; i++)
      gameList.value[i].selected = false

    gameList.value[index].selected = true
    openGameId = gameList.value[index].gameId
    fen.value = gameList.value[index].fen
    orientation.value = gameList.value[index].color.toLowerCase()

    //console.log("OPEN GAME ID ",openGameId)

    toolbarElements.value[TOOLBAR_GOTO].disabled = false
    toolbarTrigger.value++
  }
  
  function processJsonResponse(json) {
    //console.log(" in open games list callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    if (json.hasOwnProperty('nowPlaying') == false)
      return
        
    const playArray = json["nowPlaying"]
    for (var i = 0; i < playArray.length; i++) {
      const game = playArray[i]
      
      //console.log("GAME ",i,game)

      // has to be standard variant

      const variant = game["variant"]
      const gameType = variant["name"]
      if (gameType != "Standard")
        continue

      // can only play rapid, classic
      const speed = game["speed"]
      if (speed != "correspondence" &&  speed != "rapid" && speed != "classical")
        continue

      const opponent = game["opponent"]
      //console.log("*** opponent",opponent)
      var opponentName = ""

      if (opponent.hasOwnProperty('ai'))
        opponentName = "ai"
      else
        opponentName = opponent["username"]
        
      const fen = game["fen"]
      const gameId = game["gameId"]
      const rated = game["rated"]
      const isMyTurn = game["isMyTurn"]
      const color = game["color"]

      if (fen == null || gameId == null || rated == null || speed == null || 
                    isMyTurn == null || color == null)
        continue   

      const oneGame = {
        index : i,
        name : opponentName,
        fen : fen,
        gameId : gameId,
        rated : (rated != 0) ? t("rated") : t("casual"),
        speed : t(speed),
        myTurn : (isMyTurn != 0) ? "(*)" : "",
        opponentTurn : (isMyTurn != 0) ? "" : "(*)",
        color : (color == "white") ? t("White") : t("Black"),
        selected : false

      }
      gameList.value.push(oneGame)
    }
    showLoadingGames.value = false
  }

  function getOpenGames() {
    gameList.value = []
    toolbarElements.value[TOOLBAR_GOTO].disabled = true
    toolbarTrigger.value++
    openGameId = ""
    showLoadingGames.value = true
    const urlStr = "https://lichess.org/api/account/playing?nb=50"
    getLichessData(urlStr, lichessAccessToken,null, processJsonResponse) 
  }

</script>

<style scoped>

#open-game-list-container {
  position : relative;
}

#open-game-list {
  position : relative;
  line-height: 1.4em;
  overflow-y: auto;
  font-family: "Nunito", sans-serif;   /* rounded */
  text-align: center;
}


.game-list-center-text {
  text-align: center;
  margin-bottom : 5px;
  margin-top : 5px;
}

.extra-padding {
  padding-bottom : 2px;
  padding-top : 2px;
}

.game-list-center-text:hover {
    background: #4c6ca0;
}

.repselector-heading-color {
  background: #4c6ca0;
  color : white;
}

.repselector-left-text {
  text-align: left;
  margin-bottom : 5px;
  margin-top : 5px;
}

.reptree-move-text-light {
  color : 0xfff;
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  border : solid 1px #fff;
  border-radius: 3px;
}
</style>
